import React from "react";
import { pricing } from "../data/content";
type PriceTagProps = {
  tone?: "light" | "dark";
};
export function PriceTag({
  tone = "light"
}: PriceTagProps) {
  const {
    currency,
    amount
  } = splitPrice(pricing.current);
  const isLight = tone === "light";
  return <div data-id="element-173" data-mp="1jpbhhi77zy2y">
      <div className="flex flex-col items-center gap-1 sm:flex-row sm:justify-center sm:gap-6" data-id="element-174" data-mp="1oltge1fvd27d">
        <span className={`text-lg font-semibold line-through decoration-2 sm:text-2xl ${isLight ? "text-[#C24B55] decoration-[#C24B55]" : "text-[#F3A1A7] decoration-[#F3A1A7]"}`} data-id="element-175" data-mp="19x5llxdukwih">
          <span className="sr-only" data-id="element-176" data-mp="10wr1308pjlg1">Antes </span>
          {pricing.original}
        </span>

        <span className="relative inline-flex items-start" data-id="element-177" data-mp="14y2jakp954e7">
          <span className="sr-only" data-id="element-178" data-mp="14ylyhtnipeoj">Ahora </span>
          {currency && <span aria-hidden="true" className={`absolute right-full top-2 mr-1.5 text-base font-bold tracking-wide sm:top-3 sm:text-lg ${isLight ? "text-navy/70" : "text-gold"}`} data-id="element-179" data-mp="qzck8zivgun7">
              {currency}
            </span>}
          <span className="sr-only" data-id="element-180" data-mp="2wsz88dp8i75l">{currency} </span>
          <span className={`font-display text-7xl font-extrabold leading-none sm:text-8xl ${isLight ? "text-navy" : "text-gold-gradient"}`} data-id="element-181" data-mp="2ws6c06nwj01p">
            {amount}
          </span>
        </span>
      </div>
      <p className={`mx-auto mt-3 max-w-sm text-xs leading-snug ${isLight ? "text-muted" : "text-white/70"}`} data-id="element-182" data-mp="2i3jkz7owwjun">
        {pricing.currencyNote}
      </p>
    </div>;
}

// "USD 19" → { currency: "USD", amount: "19" }
function splitPrice(value: string) {
  const match = value.trim().match(/^(\D*?)\s*([\d.,]+)\s*(\D*)$/);
  if (!match) return {
    currency: "",
    amount: value
  };
  return {
    currency: (match[1] || match[3]).trim(),
    amount: match[2]
  };
}